import { RequestQueryParamsModel } from "../http.interface";

export class WarehouseLocationListParams implements RequestQueryParamsModel {
  page?: number;
  limit?: number;
  search?: string;
  sorts?: string;
  byUser?: boolean;
}
